import API from "./API";

async function doPostLogin(fields) {
    let params = new URLSearchParams();
    params.append('email', fields.email);
    params.append('password', fields.password);
    return API.post('/login/website', params);
}

async function doPostAuthToken(token) {
    return Promise.resolve({response:true});
}

async function doPostAskResetPassword(email) {
    return API.post('/users/password/reset/', new URLSearchParams({email: email}));
}

async function doPostResetCode(code) {
    return API.post('/users/password/reset/verify', new URLSearchParams({verification_code: code}));
}

async function doPostResetPassword(token, password) {
    return API.post('/users/password/reset/change', new URLSearchParams({reset_token: token, new_password: password}));
}

export {
    doPostLogin,
    doPostAuthToken,
    doPostAskResetPassword,
    doPostResetCode,
    doPostResetPassword,
}